/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Card_Rating_Count_OneInputs */

const en_directory_card_rating_count_one = /** @type {(inputs: Directory_Card_Rating_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} rating`)
};

const zh_directory_card_rating_count_one = /** @type {(inputs: Directory_Card_Rating_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 条评分`)
};

/**
* | output |
* | --- |
* | "{count} rating" |
*
* @param {Directory_Card_Rating_Count_OneInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_rating_count_one = /** @type {((inputs: Directory_Card_Rating_Count_OneInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_Rating_Count_OneInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_rating_count_one(inputs)
	return zh_directory_card_rating_count_one(inputs)
});
export { directory_card_rating_count_one as "directory.card.rating_count_one" }